<p>ads-control works!</p>
